import { APIParams } from './api-params.model';
import { Observable } from 'rxjs';

export abstract class APIClient {
  abstract get<T>(
    resource: string,
    params?: APIParams | undefined
  ): Observable<T>;
  abstract put<T, U>(
    resource: string,
    obj: T,
    params?: APIParams | undefined
  ): Observable<U>;
  abstract post<T>(
    resource: string,
    obj: T,
    params?: APIParams | undefined,
    reportProgress?: boolean,
    observe?: string
  ): Observable<T>;
  abstract postText(resource: string, obj: unknown): Observable<string>;
  abstract delete<T>(
    resource: string,
    params?: APIParams | undefined
  ): Observable<T>;

  abstract getFile(resource: string): any;
}
